




import Vue, { PropType } from "vue";
import { mapActions } from "vuex";
import {
  GetLoginSharingCodeRequest,
  GetLoginSharingCodeResponse
} from "@/containers/loginSharing/api";
import log from "loglevel";

export interface ClipStudioAutoLauncherProps {
  url: string;
  target: string;
  isWithLoginSharing: boolean;
  loginSharingPageName: string;
}

export default Vue.extend({
  name: "vc-clip-studio-auto-launcher",
  props: {
    url: {
      type: String as PropType<ClipStudioAutoLauncherProps["url"]>,
      default: ""
    },
    target: {
      type: String as PropType<ClipStudioAutoLauncherProps["target"]>,
      default: "_self"
    },
    isWithLoginSharing: {
      type: Boolean as PropType<
        ClipStudioAutoLauncherProps["isWithLoginSharing"]
      >,
      default: false
    },
    loginSharingPageName: {
      type: String as PropType<
        ClipStudioAutoLauncherProps["loginSharingPageName"]
      >,
      default: "vc-clip-studio-auto-launcher"
    }
  },
  mounted() {
    this.launchClipStudio();
  },
  methods: {
    ...mapActions("loginSharing", ["getLoginSharingCode"]),
    async launchClipStudio() {
      if (this.url) {
        if (typeof window.cancelScreenLock === "function") {
          window.cancelScreenLock();
        }
        if (!this.isWithLoginSharing) {
          window.open(this.url, this.target);
          return;
        }
        const requestData: GetLoginSharingCodeRequest = {
          pageName: this.loginSharingPageName
        };
        try {
          const res: GetLoginSharingCodeResponse = await this.getLoginSharingCode(
            requestData
          );
          const iceScheme =
            this.url +
            (this.url.includes("?")
              ? "&"
              : this.url.endsWith("/")
              ? "?"
              : "/?") +
            "commonparametertype[]=login_sharing" +
            "&login_sharing_code=" +
            res.loginSharingCode +
            "&login_sharing_valid_seconds=" +
            res.loginSharingValidSeconds;
          window.open(iceScheme, this.target);
        } catch (error) {
          log.error(error);
          window.open(this.url, this.target);
        }
      }
    }
  }
});
